import { render, staticRenderFns } from "./SearchGrid.vue?vue&type=template&id=d23d70c8&scoped=true"
import script from "./SearchGrid.vue?vue&type=script&lang=js"
export * from "./SearchGrid.vue?vue&type=script&lang=js"
import style0 from "./SearchGrid.vue?vue&type=style&index=0&id=d23d70c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23d70c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GridList: require('/var/www/html/jayuvillage/components/GridList.vue').default})
